import { render, staticRenderFns } from "./TeamCompetitionForm.vue?vue&type=template&id=a54a34de&scoped=true&"
import script from "./TeamCompetitionForm.vue?vue&type=script&lang=js&"
export * from "./TeamCompetitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54a34de",
  null
  
)

export default component.exports